var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from "events";
import Platform from "../common/plat";
import { createDeeplink } from "../common/scheme";
import { AppDownloadStatus } from "../../../common/constants";
/**
 * 处理第三方的下载
 * 无TBS等能力
 */
var OtherDownloader = /** @class */ (function (_super) {
    __extends(OtherDownloader, _super);
    function OtherDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'OtherDownloader';
        _this.opt = __assign({}, opt);
        _this.count = 0;
        _this.status = true;
        return _this;
    }
    OtherDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            var autoActive;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        autoActive = this.opt.autoActive;
                        if (!autoActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.tryOpen()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    OtherDownloader.prototype.start = function () {
        var _this = this;
        var appStore = this.opt.appStore;
        if (Platform.isIos) {
            window.location.href = appStore;
        }
        else {
            this.tryOpen();
            this.tryDownload();
        }
        // 延迟一秒后可点击
        setTimeout(function () {
            _this.emit("downdone");
        }, 500);
    };
    OtherDownloader.prototype.pause = function () { };
    OtherDownloader.prototype.resume = function () {
        this.start();
    };
    OtherDownloader.prototype.install = function () {
        this.start();
    };
    OtherDownloader.prototype.open = function () {
        var _a = this.opt, active = _a.active, packagename = _a.packagename;
        if (active) {
            return (location.href = active);
        }
        location.href = createDeeplink(packagename);
    };
    OtherDownloader.prototype.tryDownload = function () {
        var url = this.opt.url;
        if (url && this.count < 1) {
            console.log('tryDownload by iframe');
            this.count += 1;
            var ifr_1 = document.createElement("iframe");
            ifr_1.src = url;
            ifr_1.style.display = "none";
            document.body.appendChild(ifr_1);
            setTimeout(function () {
                document.body.removeChild(ifr_1);
            }, 500);
        }
        else {
            console.log('tryDownload by url');
            window.location.href = url;
        }
    };
    OtherDownloader.prototype.tryOpen = function (cb) {
        var _this = this;
        var active = this.opt.active;
        if (active && this.count < 1) {
            this.count++;
            var ifr_2 = document.createElement("iframe");
            ifr_2.src = active;
            ifr_2.style.display = "none";
            document.body.appendChild(ifr_2);
            setTimeout(function () {
                document.body.removeChild(ifr_2);
                _this.emit('open_error');
                _this.status = false;
                cb && cb();
            }, 500);
        }
    };
    // 尝试探测
    OtherDownloader.prototype.isInstalled = function () {
        return false;
    };
    OtherDownloader.prototype.getStatus = function () {
        return AppDownloadStatus.TASK_STATUS_NONE;
    };
    OtherDownloader.prototype.getProgress = function () {
        return 0;
    };
    return OtherDownloader;
}(EventEmitter));
export default OtherDownloader;
